<template>
  <div>
    <div class="mb-5 mx-3">
      <div class="row mt-2">
        <div class="col-md-12">
          <h3 class="mt-3">Filter by event attributes</h3>
          <label for="inputEmail">
            Show conversion for events with the following attributes:
          </label>
        </div>
      </div>

      <div>
        <div
          v-for="(list, key) in layer"
          v-bind:key="key"
          class="grouped-key"
        >
          <div
            class="bg-light rounded pt-4 px-4 condition-block"
            :key="refresh"
          >
            <div v-for="(item, i) in list" v-bind:key="i">
              <div
                :id="'do-show-' + key"
                class="row mt-1 key-records"
                :class="'row-' + item.id"
              >
                <div class="col-md-12 mx-0 px-0">
                  <input class="px-2 pretty-form key d-inline w-25" 
                    :value="item.key"
                    style="height: 44px !important;width:40%;"
                    @change="updateVal(key, item.id)"
                    placeholder="Key"
                  />
                  <select
                    type="text"
                    class="operand d-inline custom-select w-25"
                    :value="item.operand"
                    @change="updateVal(key, item.id)"
                  >
                    <option value="=">Equals</option>
                    <option value="!=">Not equals</option>
                    <option value=">">Greater than</option>
                    <option value=">=">Greater equals</option>
                    <option value="<">Lesser than</option>                    
                    <option value="<=">Lesser equals</option>
                  </select>
                  <input
                    type="text"
                    :value="item.value"
                    @keyup="updateVal(key, item.id)"
                    class="pretty-form value d-inline w-auto px-2 ml-2"
                    style="height: 44px !important;width:40%;"
                    placeholder="value"
                    autocomplete="off"
                  />
                  <span
                    style="display: none"
                    @click="deleteRow(item.id)"
                    :class="
                      'text-danger ' +
                      key +
                      '-delete remove-key-btn cursor-pointer'
                    "
                  >
                    <font-awesome-icon icon="trash" />
                </span>
                </div>
                <div class="col-md-12 text-center or-btn my-2">
                  <span
                    class="and text-primary cursor-pointer"
                    @click="addRow(key)"
                    >+ AND</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 text-center or-btn my-2">
            <p class="or" @click="addGroup()">
              <em class="text-primary cursor-pointer">+ OR</em>
            </p>
          </div>
        </div>
      </div>

      <input
        type="hidden"
        style="width: 100%"
        id="attributeJSON"
        v-model="attributeJSON"
      />
      <button class="btn btn-first" @click="saveAttributes">Save Attribute</button>
      <button class="btn btn-third" @click="clearAttribute()">Clear All</button>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  props: ['data', 'label'],
  data: function () {
    return {
      isHowuku: false,
      onlyShowSpecified: true,
      layer: [],
      lastInsertedId: {},
      refresh: 0,
      attributeJSON: '',
      notProAbove: false,
      notAllowedPlan: [20,21,22,300]
    }
  },
  watch: {
    layer: function (val) {
      this.attributeJSON = JSON.stringify(val)
    }
  },
  created() {
    this.composeRules()
  },
  mounted() {
    this.isHowuku =
      window.location.host === 'app.howuku.com' ||
      window.location.host.includes('localhost')

    let planId = this.$session.get('paid_plan')
    this.notProAbove =
      planId === 0 || planId === 1 || planId === 5 || planId === 4

    if (this.$session.get('lifetimedeal')) this.notProAbove = false
    setTimeout(() => {
      if (this.data) {
        this.layer = JSON.parse(this.data)
        if (this.layer.length) this.onlyShowSpecified = true
      } else {
        this.lastInsertedId[0] = this.random()
        this.layer.push([
          {
            id: this.lastInsertedId[0],
            key: '',
            operand: '=',
            value: ''
          }
        ])
      }

      this.updateDeleteButton()
    }, 400)
  },
  methods: {
    showUpgrade() {
      let catogoryFirst = [20,21,22]
      let catogorySecond = [300,301,302]
      let descriptionText
      let titleText
      if (catogoryFirst.includes(this.$session.get('paid_plan'))) {
        titleText = 'Upgrade Account'
        descriptionText = 'Your current plan not support this feature, update your plan to use this feature.'
      } else if (catogorySecond.includes(this.$session.get('paid_plan'))) {
        titleText = 'Upgrade To Growth Plan'
        descriptionText = 'You need to upgrade your account to Growth plan to use this feature.'
      }
      this.$swal.fire({
        title: titleText,
        text: descriptionText,
        type: 'warning',
        confirmButtonColor: '#2167f5'
      })
    },
    composeRules() {

    },
    updateVal(index, id) {
      for (let i = 0; i < this.layer[index].length; i++) {
        if (this.layer[index][i].id === id) {
          this.layer[index][i].key = document.querySelector(
            '.row-' + id + ' input.key'
          ).value
          this.layer[index][i].operand = document.querySelector(
            '.row-' + id + ' select.operand'
          ).value
          this.layer[index][i].value = document.querySelector(
            '.row-' + id + ' input.value'
          ).value          
        }
      }

      this.layer.push([])
      this.layer.pop()
    },
    updateDeleteButton() {
      setTimeout(() => {
        let btnDelete = document.getElementsByClassName('remove-key-btn')
        if (btnDelete) {
          for (let i in btnDelete) {
            if (btnDelete[i] instanceof HTMLElement) {
              btnDelete[i].style.display =
                document.querySelectorAll('.pretty-form').length >= 2
                  ? 'inline'
                  : 'none'
            }
          }
        }
      }, 100)
    },
    clearAttribute() {
      this.attributeJSON = '';
      this.layer = [];
      this.lastInsertedId = {};
      this.refresh++;
      this.$emit('save', null);
      setTimeout(() => {
        this.$modal.hide(this.$parent.name);        
      }, 100);
    },

    updateORandAND() {
      setTimeout(() => {
        let groups = document.getElementsByClassName('grouped-key')

        for (let i = 0; i < groups.length; i++) {
          let ands = groups[i].querySelectorAll('.and')
          let lastAnd = null
          for (let j = 0; j < ands.length; j++) {
            if (ands[j]) {
              ands[j].textContent = 'AND'
              ands[j].classList.remove('text-primary')
              ands[j].classList.remove('cursor-pointer')
              lastAnd = ands[j]
            }
          }
          if (lastAnd) {
            lastAnd.textContent = '+ AND'
            lastAnd.classList.add('text-primary')
            lastAnd.classList.add('cursor-pointer')
          }

          let ors = document.querySelectorAll('p.or em')
          let lastOrs = null
          for (let j = 0; j < ors.length; j++) {
            if (ors[j]) {
              ors[j].textContent = 'OR'
              ors[j].classList.remove('text-primary')
              ors[j].classList.remove('cursor-pointer')
              lastOrs = ors[j]
            }
          }
          if (lastOrs) {
            lastOrs.textContent = '+ OR'
            lastOrs.classList.add('text-primary')
            lastOrs.classList.add('cursor-pointer')
          }
        }
      }, 10)
    },
    deleteRow(id) {
      document
        .getElementsByClassName('row-' + id)[0]
        .parentNode.removeChild(document.getElementsByClassName('row-' + id)[0])

      for (let i = 0; i < this.layer.length; i++) {
        for (let j = 0; j < this.layer[i].length; j++) {
          if (this.layer[i][j].id === id) {
            this.layer[i].splice(j, 1)
            break
          }
        }
      }

      this.updateDeleteButton()
      this.updateORandAND()

      setTimeout(() => {
        // remove the group container
        for (let i in this.layer) {
          if (!this.layer[i].length) {
            this.layer.splice(i, 1)
            break
          }
        }
        this.refresh++
      }, 10)
    },
    addRow(index) {
      let id = this.random()
      let data = {
        id: id,
        key: 'key',
        operand: '=',
        value: ''
      }

      if (!this.layer[index]) this.layer[index] = []

      this.layer[index].push(data)
      this.lastInsertedId[index] = id
      this.updateDeleteButton()
      this.updateORandAND()
    },
    addGroup() {
      let id = this.random()
      let data = {
        id: id,
        key: 'key',
        operand: '=',
        value: ''
      }

      this.layer.push([data])
      this.lastInsertedId[this.layer.length - 1] = id

      this.updateDeleteButton()
      this.updateORandAND()
    },
    random() {
      return Math.floor(Math.random() * 1000000 + 1)
    },
    saveAttributes() {
      this.$emit('save', this.attributeJSON);
      this.$modal.hide(this.$parent.name);
    }
  }
}
</script>

<style>
p.and {
  border-bottom: 1px dashed #d6dde3;
  margin: 0.5em 0 1.7em 0;
  text-align: center;
}

.or {
  font-size: 1.2em;
  font-weight: normal;
  color: #93a1af;
}

p.and em {
  color: #93a1af;
  background-color: rgb(255, 255, 255);
  font-size: 1.2em;
  font-weight: normal;
  margin: 0 10px;
  padding: 0 10px;
  position: relative;
  top: 12px;
}

.pretty-form {
  vertical-align: top;
  height: 38px;
  line-height: 20px;
  -webkit-appearance: none;
  border-radius: 4px;
  border-width: 1px;
  border-style: solid;
  /* border-color: rgb(247, 247, 247); */
  -o-border-image: initial;
  border-image: initial;
  border: 1px solid #ced4da;
  /* background: rgb(247, 247, 247); */
  -webkit-box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05),
    0 2px 3px 0 rgba(0, 0, 0, 0.05);
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 3px 0 rgba(0, 0, 0, 0.05);
  -webkit-transition: all 0.2s ease 0s;
  transition: all 0.2s ease 0s;
  outline: 0px;
  color: rgba(0, 0, 0, 1);
  font-size: 16px;
  font-weight: 500;
}

.condition-block {
  /* border: 1px solid #dedede !important; */
}
</style>



// WEBPACK FOOTER //
// src/components/AttributeForm.vue